import styled from "styled-components";
import { Panel } from "react-bootstrap";

export const PanelWrapper = styled(Panel)`
    margin-bottom: 0px;
`;

export const ProductWrapper = styled.div`
    & > .product:nth-child(even) {
        margin-top: 20px;
        margin-bottom: 0px;
    }

    & > .product:last-child {
        margin-bottom: 0px;
    }
`;